import { render, staticRenderFns } from "./MerchantStaffAddEdit.vue?vue&type=template&id=b288cc9a"
import script from "./MerchantStaffAddEdit.vue?vue&type=script&lang=js"
export * from "./MerchantStaffAddEdit.vue?vue&type=script&lang=js"
import style0 from "./MerchantStaffAddEdit.vue?vue&type=style&index=0&id=b288cc9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports